import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

const LeftAlignedGrid = styled(Grid)`
  && {
    text-align:left;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const RightAlignedGrid = styled(Grid)`
  && {
    text-align:right;
    margin-bottom:8px;
    font-size:17px;
  }
`;
const DateText = styled.div`
  font-size:17px;
`;

const YieldMaintenanceAgencyStyleResult = ({ result, prepaymentResult }) => (
  <>
    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Discount Rate</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.interpolatedYieldToMaturityOfTreasurySecurities, 3, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Discount Lookback</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>
      {prepaymentResult.lookbackDays}
      {" "}
      business days
    </RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Prepayment Penalty</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.yieldMaintenanceAmount, 2, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Minimum Penalty</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.minimumPrepaymentPenalty, 2, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Rate Differential (%)</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.replacementRate, 3, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Agency Style PV Factor</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatDecimal(result.presentValueFactor, 2, "-")}</RightAlignedGrid>
    <LeftAlignedGrid item xs={6}>Prepayment Factor (%)</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.prepaymentFactor, 2, "-")}</RightAlignedGrid>
  </>
);
export default YieldMaintenanceAgencyStyleResult;
